import React from 'react';
import './AjaxComponents.css';
import { Images } from '../../themes';
import { capitalize } from '../../lib/Utils';

const deviceTypes = [
  { deviceType: 'DoorProtect', imageType: 'DoorProtect' },
  { deviceType: 'MotionProtect', imageType: 'MotionProtect' },
  { deviceType: 'FireProtect', imageType: 'FireProtect' },
  { deviceType: 'GlassProtect', imageType: 'GlassProtect' },
  { deviceType: 'LeaksProtect', imageType: 'LeaksProtect' },
  { deviceType: 'MotionProtectCurtain', imageType: 'MotionProtectCurtain' },
  { deviceType: 'RangeExtender', imageType: 'RangeExtender' },
  { deviceType: 'CombiProtect', imageType: 'CombiProtect' },
  { deviceType: 'FireProtectPlus', imageType: 'FireProtect' },
  { deviceType: 'Keypad', imageType: 'Keypad' },
  { deviceType: 'KeypadPlus', imageType: 'Keypad' },
  { deviceType: 'KeypadCombi', imageType: 'Keypad' },
  { deviceType: 'SpaceControl', imageType: 'SpaceControl' },
  { deviceType: 'Button', imageType: 'DoorProtect' },
  { deviceType: 'DoubleButton', imageType: 'DoubleButton' },
  { deviceType: 'MotionProtectPlus', imageType: 'MotionProtect' },
  { deviceType: 'DoorProtectPlus', imageType: 'DoorProtect' },
  { deviceType: 'UniversalDevice', imageType: 'Hub' },
  { deviceType: 'Transmitter', imageType: 'Transmitter' },
  { deviceType: 'Socket', imageType: 'Socket' },
  { deviceType: 'WallSwitch', imageType: 'WallSwitch' },
  { deviceType: 'Relay', imageType: 'Relay' },
  { deviceType: 'MotionProtectOutdoor', imageType: 'MotionProtectOutdoor' },
  { deviceType: 'DualCurtainOutdoor', imageType: 'MotionProtectCurtain' }, // not found
  { deviceType: 'StreetSiren', imageType: 'StreetSiren' },
  { deviceType: 'HomeSiren', imageType: 'HomeSiren' },
  { deviceType: 'MotionCam', imageType: 'MotionCam' },
  { deviceType: 'MotionCamOutdoor', imageType: 'MotionCam' },
  { deviceType: 'StreetSirenDoubleDeck', imageType: 'StreetSirenDoubleDeck' },
  { deviceType: 'MultiTransmitter', imageType: 'MultiTransmitter' },
  { deviceType: 'MultiTransmitterWireInput', imageType: 'MultiTransmitter' },
];

const DeviceComponent = ({ device, rooms }) => {
  let { deviceType, deviceName, roomId, color, online } = device;
  color = color || 'WHITE';
  let roomName = '';
  if (rooms && rooms.length > 0) {
    const matchedRoom = rooms.find((room) => room.id === roomId);
    if (matchedRoom && matchedRoom.roomName) {
      roomName = matchedRoom.roomName;
    }
  }
  const matchingType = deviceTypes.find((dev) => deviceType === dev.deviceType);
  const imageType = matchingType ? matchingType.imageType : 'Hub'; //universal device
  const imageName = `${imageType}${capitalize(color)}`;
  const imageSource = Images[imageName] ? Images[imageName] : Images[`Hub${capitalize(color)}`];

  return (
    <div className="ajax_device_container">
      <img src={imageSource} alt={deviceType} />
      <div className="ajax_device_text_container">
        <span className="ajax_device_name">{deviceName}</span>
        <span className="ajax_device_room_name">{roomName}</span>
      </div>
      <div className="ajax_device_status_container">
        <span className={`status_dot ${online ? 'button_on' : 'button_off'}`}></span>
      </div>
    </div>
  );
};

export default DeviceComponent;
